<div class="borrower-info" fxLayout="row" fxLayoutAlign="start center">
  <button (click)="goBack()" mat-icon-button color="primary" aria-label="Example icon button with a home icon">
    <mat-icon>keyboard_backspace</mat-icon>
  </button>
  <span style="cursor:pointer" (click)="goBack()">Search another borrower...</span>
</div>
<mat-accordion #accordion class="container" multi>
  <mat-expansion-panel expanded='true'>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Borrower Info
      </mat-panel-title>
      <mat-panel-description>
        <div fxFlex="1 1 100%" fxLayout="row" fxLayoutAlign="end center">
          <mat-icon>account_circle</mat-icon>
        </div>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div fxLayout="row" fxLayoutAlign="space-between">
      <div fxLayout="column">
        <p>Name: <span class="value">{{borrowerModel?.name}}</span></p>
        <p>Age: <span class="value">{{borrowerModel?.age}} years</span></p>
      </div>
      <div fxLayout="column">
        <p>SIN: <span class="value">{{borrowerModel?.sin}}</span></p>
        <p>BorrowerId: <span class="value">{{borrowerModel?.borrowerId}}</span></p>
      </div>
      <div fxLayout="column">
        <p>Registration Date: <span class="value">{{borrowerModel?.registrationDate | date}}</span></p>
        <p>Loan Status: <span class="value">{{borrowerModel?.loanStatus}}</span></p>
      </div>
    </div>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Usage Stats
      </mat-panel-title>
      <mat-panel-description>
        <div fxFlex="1 1 100%" fxLayout="row" fxLayoutAlign="end center">
          <mat-icon>timeline</mat-icon>
        </div>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div fxLayout="row" fxLayoutAlign="start center">
      <span>Intensity:</span> <span matTooltip="Compared with other users"><i
          class="material-icons md-9 md-orange">lens</i>Medium</span>
    </div>
    <div fxLayout="column">
      <div fxLayoutAlign="space-between" fxFlex="1 1 100%">
        <div fxLayout="column" fxFlex="33%" fxLayoutAlign="center center">
          <h5>Device used (all visits)</h5>
        </div>
        <div fxLayout="column" fxFlex="33%" fxLayoutAlign="center center">
          <h5>Most viewed pages</h5>
        </div>
        <div fxLayout="column" fxFlex="33%" fxLayoutAlign="center center">
          <h5>Last year visits</h5>
        </div>
      </div>
      <div fxLayout="row" fxFlex="1 1 100%">
        <div fxLayout="column" fxFlex="33%" fxLayoutAlign="center">
          <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
            [legend]="barChartLegend" [chartType]="barChartType">
          </canvas>
        </div>
        <div fxLayout="column" fxFlex="33%" fxLayoutAlign="center">
          <div fxLayout="column">
            <canvas baseChart [datasets]="mostViewedPagesData" [labels]="mostViewedPages" [options]="barChartOptions"
              [legend]="barChartLegend" [chartType]="barChartType">
            </canvas>
          </div>
        </div>
        <div fxLayout="column" fxFlex="33%" fxLayoutAlign="center">
          <div fxLayout="column">
            <canvas baseChart [datasets]="visitsPerMonth" [labels]="months" [options]="barChartOptions"
              [legend]="barChartLegend" chartType="line">
            </canvas>
          </div>
        </div>

      </div>
    </div>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Data analysis
      </mat-panel-title>
      <mat-panel-description>
        <div fxFlex="1 1 100%" fxLayout="row" fxLayoutAlign="end center">
          <!-- <span>Insights about the borrower produced by our AI engine</span> -->
          <mat-icon>insights</mat-icon>
        </div>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="start center">
        <i class="material-icons md-red">report</i>
        <span>User is ignoring Action Required items</span>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center">
        <i class="material-icons md-orange">warning</i>
        <span>Based on geolocation current address may be wrong</span>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center">
        <i class="material-icons md-orange">warning</i>
        <span>Based on geolocation current phone number may not be up-to-date</span>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center">
        <i class="material-icons md-green">check_circle</i>
        <span>All secure inbox messages are read.</span>
      </div>
    </div>
  </mat-expansion-panel>

  <mat-expansion-panel expanded='true'>
    <mat-expansion-panel-header>
      <mat-panel-title>
        User sessions
      </mat-panel-title>
      <mat-panel-description>
        <div fxFlex="1 1 100%" fxLayout="row" fxLayoutAlign="end center">
          <!-- <span>User recorded activity on StudentHub</span> -->
          <mat-icon>insert_chart</mat-icon>
        </div>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <table mat-table [dataSource]="userSummaryLogs" class="mat-elevation-z8 full-width">


      <ng-container matColumnDef="sid">
        <th mat-header-cell *matHeaderCellDef> SessionId </th>
        <td mat-cell *matCellDef="let element"> {{element.sid}} </td>
      </ng-container>
    
      
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef> Date/time started </th>
        <td mat-cell *matCellDef="let log"> {{getStartDate(log)}} </td>
      </ng-container>

      <ng-container matColumnDef="duration">
        <th mat-header-cell *matHeaderCellDef> Time spent on site </th>
        <td mat-cell *matCellDef="let log"> {{getDuration(log)}} </td>
      </ng-container>
     
      <ng-container matColumnDef="count">
        <th mat-header-cell *matHeaderCellDef> Number of records </th>
        <td mat-cell *matCellDef="let element"> {{element.recordsCount}} </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>  </th>
        <td mat-cell *matCellDef="let log"> <button mat-raised-button color="primary" (click)="viewLogs(log)">Check details</button> </td>
      </ng-container>
     
      
    
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </mat-expansion-panel>

  

</mat-accordion>